export default __webpack_public_path__ + "static/media/ialign-logo.2061dc6d.webp";